export default "__VITE_ASSET__pZc$jZeh__"